import React, { createElement, Suspense, useEffect } from 'react';
import { render } from 'react-dom';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { HashRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { RecoilRoot, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { userState, userTokenState, userSession } from '@app.shared/state';
import { getSession } from '@app.api';
var encrypter = require('object-encrypter');
var engine = encrypter(process.env.ENCRYPT_SECRET, { ttl: true });
import routes from './routes';

const queryClient = new QueryClient();

const AuthProvider = ({ children }) => {
  let location = useLocation();
  const authToken = useRecoilValue(userTokenState);
  const currentSession = useRecoilValue(userSession);
  const resetToken = useResetRecoilState(userTokenState);
  const resetUser = useResetRecoilState(userState);
  const navigate = useNavigate();

  const sessionData = engine.decrypt(authToken);

  const { data: session } = useQuery(['student_stats', { id: currentSession, token: authToken }], getSession, {
    enabled: !!currentSession,
    refetchOnMount: true,
    onSuccess: (response) => {
      if (response?.error) {
        resetToken();
        resetUser();
        navigate('/login');
      }
    },
  });

  useEffect(() => {
    if (!sessionData && location.pathname !== '/login') {
      resetToken();
      resetUser();
      navigate('/login');
    }
    if (sessionData && sessionData.userType !== 'admin') {
      resetToken();
      resetUser();
      navigate('/login');
    }
  }, [sessionData, location]);

  return <>{children}</>;
};

const ManagementDashboard = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <Router hashType="slash">
          <AuthProvider>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                {routes.map((route, index) => (
                  <Route key={index} {...route} element={<route.main></route.main>}></Route>
                ))}
              </Routes>
            </Suspense>
          </AuthProvider>
        </Router>
      </RecoilRoot>
    </QueryClientProvider>
  );
};

if (!customElements.get('management-dashboard')) {
  customElements.define(
    'management-dashboard',
    class extends HTMLElement {
      connectedCallback() {
        const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
        render(createElement(ManagementDashboard, Object.fromEntries(props)), this);
      }
    }
  );
}
